import React, { useEffect, useState } from 'react'

import SideBar from 'components/siderbar'
import Header from 'components/header'
import CardDynamic from 'components/card_dynamic'

import Colors from 'utils/colors'
import { Service } from 'services/api'
import Renderif from 'utils/renderif'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { Bubble } from 'react-chartjs-2';
import { Button } from 'react-bootstrap'


// import faker from 'faker';


function countByDayAndHour(data) {
  const resultMap = {};

  data.forEach(item => {
    const date = new Date(item.createdAt);

    const day = date.getUTCDate(); // use getDate() if you want local time
    const hour = date.getUTCHours();

    const dayKey = date.toISOString().split("T")[0];

    // Create day if not exists
    if (!resultMap[dayKey]) {
      resultMap[dayKey] = {
        day,
        date: item.createdAt,
        hours: {}
      };
    }

    // Create hour if not exists
    if (!resultMap[dayKey].hours[hour]) {
      resultMap[dayKey].hours[hour] = 0;
    }

    resultMap[dayKey].hours[hour]++;
  });

  // Convert hours object to array format
  return Object.values(resultMap).map(dayObj => ({
    day: dayObj.day,
    date: dayObj.date,
    hours: Object.entries(dayObj.hours).map(([hour, count]) => ({
      hour: Number(hour),
      count
    }))
  }));
}


const Home = () => {

  ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
  );

  const options = {
    responsive: true,
    maintainAspectRatio: true, // Set to true if you want to use aspectRatio
    aspectRatio: 4, // Adjust this value (e.g., 0.5 for a squatter chart)
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: false,
        text: '',
      },
    },
  };
  

  

 

  const [state, setState] = useState({
    loading: false,
    _activities: [],
    _activitySelected: null,
    activities: [[],[],[],[]],
    result:[[],[],[]],
    activities_stats: [[],[],[]],
    activities_days:[],
    activities_lose:[[],[],[]],
    activities_win:[[],[],[]],
    max_count: 0,
    chardata:{
      labels:[],
      datasets: [
        {
          label: 'Dataset 1',
          data: [],
          borderColor: 'rgba(139, 92, 200, 0.4)',
          backgroundColor: 'rgba(139, 92, 200, 0.4)',
        },
      ],
    },
    yearSelected:new Date().getFullYear(),
    monthSelected:new Date().getMonth() + 1,
    _codes:[],
    _chartdays:[]
    
    
  })
  useEffect(()=>{
    init()
    return () => {}
  },[])

  const groupByCreatedAt = (data, year, month, id) => {

    console.log(year, month, id)
    return [];
    return data.reduce((acc, item) => {
      const dateObj = new Date(item.createdAt);
      const itemYear = dateObj.getUTCFullYear();
      const itemMonth = dateObj.getUTCMonth() + 1; // months are 0-based
      const itemDay = String(dateObj.getUTCDate()).padStart(2, "0");
  
      // filter by year, month, and id
      if (itemYear === year && itemMonth === month && item.idActivity === id) {
        const date = `${itemYear}-${String(itemMonth).padStart(2, "0")}-${itemDay}`;
        acc[date] = (acc[date] || 0) + 1;
      }
      return acc;
    }, {});
  }

  const init = async () => {
    console.log("build")
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth() + 1; // months are 0-based, so +1

      let _activities = await Service('GET', 'activity')
      state._activities = _activities.data.data;
      state._activitySelected = _activities.data.data[_activities.data.data.length - 1];
      
      let _chart = await Service('GET', `result/chart/${_activities.data.data[_activities.data.data.length - 1]?.id}/${currentYear}/${currentMonth}`)
      let _result = await Service('GET', 'result')
   
    let _codes = await Service('GET', 'code')

    state._codes = _codes.data.data;
      // let _chardata = groupByCreatedAt(_result.data.data,currentYear, currentMonth, _activities.data.data[_activities.data.data.length - 1]?.id)
      let _datevalue = []
      let _datelabel = []
      
      for (const [key, value] of Object.entries(_chart.data.data)) {
        let extra_codes = 0;
        if(state._activitySelected.id === 22){
                extra_codes = _codes.data.data.filter((code)=>code.updatedAt.split('T')[0] === key.toString()).length;
              
        }

       
        
        _datevalue.push(value + extra_codes)
        _datelabel.push(key)
      }

    

       let _data = {
        labels:_datelabel,
        datasets: [
          {
            label: '',
            data: _datevalue,
            borderColor: 'rgba(139, 92, 200, 0.4)',
            backgroundColor: 'rgba(139, 92, 200, 0.4)',
          },
        ],
      };

      state.chardata = _data;

     
      state.result = _result.data.data.result;
        
     
      
      
      state.activities_lose = _result.data.data.user.filter((item)=>item.user === 'Lose');
      state.activities_lose = state.activities_lose.sort((a, b) => b.count - a.count)

      
    
      state.activities_win = _result.data.data.user.filter((item)=>item.user === 'Yelmo');

      if(state._activitySelected.id === 22){
        state.result.map((_result)=>{
          if(_result.idActivity === 22){
            _result.count = _result.count + _codes.data.data.length - state.activities_win.find((item)=>item.idActivity === 22)?.count;
          }
        })
        state.result = state.result.sort((a, b) => b.count - a.count)
        
      }
     

      
      state.activities_win.map((_item)=>{
        if(_item.idActivity === 22){
          _item.count = _codes.data.data.length;
        }
      })

       state.activities_win = state.activities_win.sort((a, b) => b.count - a.count)
       


      
   


      


     

    //   const uniqueIds = _result.data.data.reduce((acc, val) => {
    //     if(!acc.includes(val.idActivity)) {
    //       acc.push(val.idActivity);
    //     }
    //     return acc
    //   }, []);

    //   const uniquedays = _result.data.data.reduce((acc, val) => {
    //     if(!acc.includes(new Date(Date.parse(val.createdAt)).getDay())) {
    //       acc.push(new Date(Date.parse(val.createdAt)).getDay());
    //     }
    //     return acc
    //   }, []);


    //   // ['D', 'L', 'M', 'M', 'J', 'V', 'S'].map((day, i)=>{
                
    //   //   let count = state.activities_days.find((x)=>x.day === i)?.count
    //   //   console.log(count)
    //   //   if(count === undefined){
    //   //     count = 0;
    //   //   }
    //   //   if(count > state.max_count){
         
    //   //     state.max_count = count;
    //   //   }
        

    //   // })

    //    // WIN
    //    let activities_win = []
    //    uniqueIds.map((id, i) => {
    //      let count = 0;
    //      let total = 0;
    //      _result.data.data.filter((item) => item.user === "Yelmo").map((item, j) => {
    //        if(item.idActivity === id){
    //          count = count + 1;
    //          // total = total + item.result;
    //        }
    //      })
  
    //      activities_win.push({
    //        activity: _result.data.data.find((x)=>x.idActivity === id).activity === null ? {name:"Unknown"} : _result.data.data.find((x)=>x.idActivity === id).activity,
    //        count: count,
    //      })
 
       
 
    //    })
    //    state.activities_win = activities_win.sort((a, b) => b.count - a.count)
    //    state.activities_win = state.activities_win.filter((item)=> item.activity.name !== 'Unknown')
    //    console.log(state.activities_win)


    //   // LOSE
    //   let activities_lose = []
    //   uniqueIds.map((id, i) => {
    //     let count = 0;
    //     let total = 0;
    //     _result.data.data.filter((item) => item.user === "Lose").map((item, j) => {
    //       if(item.idActivity === id){
    //         count = count + 1;
    //         // total = total + item.result;
    //       }
    //     })
 
    //     activities_lose.push({
    //       activity: _result.data.data.find((x)=>x.idActivity === id).activity === null ? {name:"Unknown"} : _result.data.data.find((x)=>x.idActivity === id).activity,
    //       count: count,
    //     })

      

    //   })
    //   state.activities_lose = activities_lose.sort((a, b) => b.count - a.count)
    //   state.activities_lose = state.activities_lose.filter((item)=> item.activity.name !== 'Unknown')
     
      



    //   // STATS
    //   let activities_stats = []
    //   uniqueIds.map((id, i) => {
    //     let count = 0;
    //     let total = 0;
    //     _result.data.data.map((item, j) => {
    //       if(item.idActivity === id){
    //         count = count + 1;
    //         // total = total + item.result;
    //       }
    //     })
 
    //     activities_stats.push({
    //       activity: _result.data.data.find((x)=>x.idActivity === id).activity === null ? {name:"Unknown"} : _result.data.data.find((x)=>x.idActivity === id).activity,
    //       count: count,
    //     })

      

    //   })
    //   state.activities_stats = activities_stats.sort((a, b) => b.count - a.count)
    //   state.activities_stats = state.activities_stats.filter((item)=> item.activity.name !== 'Unknown')
    //   console.log(state.activities_stats)

    //   // DAYS
    //   let activities_days = []
    //   uniquedays.map((id, i) => {
    //     let count = 0;
    //     let total = 0;
    //     _result.data.data.map((item, j) => {
    //       if(new Date(Date.parse(item.createdAt)).getDay() === id){
    //         count = count + 1;
    //         // total = total + item.result;
    //       }
    //     })
 
    //     activities_days.push({
    //       day: id,
    //       // activity: _result.data.data.find((x)=>x.idActivity === id).activity === null ? {name:"Unknown"} : _result.data.data.find((x)=>x.idActivity === id).activity,
    //       count: count,
    //     })

    //     // console.log(total)


        
    

    //   })
    //   state.activities_days = activities_days
    //   // console.log(activities_days)
    


    // //  state.activities = _activities.data.data;
    let activities =  [[],[],[],[]];
    let index = 0;
    _activities?.data?.data.reverse()?.map((item, i)=>{

      
      if(index === 4){
        index = 0;
      }
      activities[index].push(item)
      index = index + 1
      
    })

    state.activities = activities;



    // ['D', 'L', 'M', 'M', 'J', 'V', 'S'].map((day, i)=>{
                
    //   let count = state.activities_days.find((x)=>x.day === i)?.count
    //   console.log(count)
    //   if(count === undefined){
    //     count = 0;
    //   }
    //   if(count > state.max_count){
       
    //     state.max_count = count;
    //   }
      

    // })


   
      // const perChunk = _activities.data.data.length / 4 // items per chunk    

       

      //   const items = _activities.data.data.reduce((resultArray, item, index) => {
      //       const chunkIndex = Math.floor(index / perChunk)

      //       if (!resultArray[chunkIndex]) {
      //           resultArray[chunkIndex] = [] // start a new chunk
      //       }

      //       resultArray[chunkIndex].push(item)

      //       return resultArray
      //   }, [])

      //   state.activities = items;
      //   console.log(items)

//       const chart = document.getElementById("chart")

// const hoursStart = 9
// const hoursEnd = 19
// const days = 31


// // Empty corner
// chart.appendChild(document.createElement("div"))


// // Top axis (days)
// for(let d=1; d<=days; d++){

//   const el = document.createElement("div")
//   el.className = "axis"
//   el.innerText = d

//   chart.appendChild(el)
// }


// // Rows
// for(let h=hoursStart; h<=hoursEnd; h++){

//   // Hour label
//   const hour = document.createElement("div")
//   hour.className="axis"
//   hour.innerText = h+":00"

//   chart.appendChild(hour)


//   // Cells
//   for(let d=1; d<=days; d++){

//     const cell = document.createElement("div")
//     cell.className="cell"

//     cell.dataset.day = d
//     cell.dataset.hour = h

//     chart.appendChild(cell)
//   }
// }



      setState({...state})
    }

    const paintChart = (matrixData, color = "0,123,255") => {
      console.log("PINTAR")
      console.log(matrixData)

     

      

        const _cell = document.querySelectorAll(
          `.cell`
        );
        console.log(_cell)
        _cell.forEach((el)=>{
          el.style.backgroundColor =
          `rgba(255,255,255,1)`;
        })



    
       // 1. find max count
        let max = 0;

        matrixData.forEach(day => {
          day.hours.forEach(h => {
            if (h.count > max) max = h.count;
          });
        });


        // 2. paint cells
        matrixData.forEach(day => {

          day.hours.forEach(h => {

            const cell = document.querySelector(
              `[data-day="${day.day}"][data-hour="${h.hour}:00"]`
            );

            if (!cell) return;

            // normalize opacity
            const opacity = Math.max(0.1, h.count / max);

            cell.style.backgroundColor =
              `rgba(${color}, ${opacity})`;

          });

        });

    }

    const onSearch = async () => {
     
      console.log(state._activitySelected)
      state.loading = true;
      setState({...state})

 
      let _result = await Service('GET', `result/chart/${state._activitySelected.id}/${state.yearSelected}/${state.monthSelected}`)
      let _result2 = await Service('GET', `result/chartday/${state._activitySelected.id}/${state.yearSelected}/${state.monthSelected}`)
      console.log(countByDayAndHour(_result2.data.data))

      state._chartdays = countByDayAndHour(_result2.data.data)
      paintChart(state._chartdays)
      
      

      // let _chardata = groupByCreatedAt(_result.data.data,currentYear, currentMonth, _activities.data.data[_activities.data.data.length - 1]?.id)
      let _datevalue = []
      let _datelabel = []
      for (const [key, value] of Object.entries(_result.data.data)) {
        let extra_codes = 0;
          if(state._activitySelected.id === 22){
              extra_codes =  state._codes.filter((code)=>code.updatedAt.split('T')[0] === key.toString()).length;
        }
        _datevalue.push(value + extra_codes)
        _datelabel.push(key)
      }

       let _data = {
        labels:_datelabel,
        datasets: [
          {
            label: '',
            data: _datevalue,
            borderColor: 'rgba(139, 92, 200, 0.4)',
            backgroundColor: 'rgba(139, 92, 200, 0.4)',
          },
        ],
      };

      state.chardata = _data;
      state.loading = false;
      setState({...state})

    }

    const filter = () => {
     return state.chardata;
      let _chardata = state.chardata
      let _datevalue = []
      let _datelabel = []
      for (const [key, value] of Object.entries(_chardata)) {
        _datevalue.push(value)
        _datelabel.push(key)
      }

       let _data = {
        labels:_datelabel,
        datasets: [
          {
            label: '',
            data: _datevalue,
            borderColor: 'rgba(139, 92, 200, 0.4)',
            backgroundColor: 'rgba(139, 92, 200, 0.4)',
          },
        ],
      };

      return _data;
    }

    const _options = {
      scales: {
        y: {
          beginAtZero: true,
        },
        x:{

        }
      },
    };

 const _data = {
  datasets: [
    {
      label: 'Red dataset',
      data: [
        {
          x:10,
          y:10,
          r:10
        },
          {
          x:15,
          y:15,
          r:10
        },
        {
          x:12,
          y:8,
          r:10
        }
      ],
      backgroundColor: 'rgba(255, 99, 132, 0.5)',
    },
    // {
    //   label: 'Blue dataset',
    //   data: Array.from({ length: 50 }, () => ({
    //     x: 5,
    //     y: 10,
    //     r: 15,
    //   })),
    //   backgroundColor: 'rgba(53, 162, 235, 0.5)',
    // },
  ],
};




  return (

    <div className='d-flex '>

      <SideBar />


    
      <div className='col overlfow-auto bg-primary '>
        
          <Header title="Dinámicas" subtitle="Dashboard" />

    

          <div className='container-md px-3 mt-3'>
                        <div className='row'>
                         
                            <div className='col-12 col-md-4 col-xl-3 pe-2'>
                                {
                                    state.activities[0]?.map((activity, i) => {
                                        return (
                                          <CardDynamic key={i} activity={activity} />
                                        )
                                    })
                                }
                            </div>
                            <div className='col-12 col-md-4 col-xl-3 pe-2'>
                                {
                                    state.activities[1]?.map((activity, i) => {
                                        return (
                                          <CardDynamic key={i} activity={activity} />
                                        )
                                    })
                                }
                            </div>
                            <div className='col-12 col-md-4 col-xl-3 pe-2'>
                                {
                                    state.activities[2]?.map((activity, i) => {
                                        return (
                                          <CardDynamic key={i} activity={activity} />
                                        )
                                    })
                                }
                            </div>
                            <div className='col-12 col-md-4 col-xl-3 pe-2'>
                                {
                                    state.activities[3]?.map((activity, i) => {
                                        return (
                                          <CardDynamic key={i} activity={activity} />
                                        )
                                    })
                                }
                            </div>

                         
                        </div>
          </div>

          <div className='container-md px-3 mt-3'>

            <div className='bold f-28 text-white mt-5'>Estadísticas</div>

          

            <div className='card-container'>

            <div className='text-primary bold f-18 mb-3'>Dias Jugados</div>  

              <div className='d-flex mb-3'>

              
                <div className='col d-flex'>
                <div className='col'>
                  <div className='f-16 my-1'>Año:</div>
                  <select value={state.yearSelected} onChange={(evt)=>{

                      state.yearSelected = evt.currentTarget.value;
                      setState({...state})
                      
                  }} className='form-control'>
                      <option value="2025">2025</option>
                      <option value="2026">2026</option>
                    
                
                  </select>
                </div>

                <div className='mx-2'></div>

                <div className='col'>
                <div className='f-16 my-1'>Mes:</div>
                <select value={state.monthSelected} onChange={(evt)=>{
                       state.monthSelected = evt.currentTarget.value;
                       setState({...state})

                }} className='form-control'>
                    <option value="1">Enero</option>
                    <option value="2">Febrero</option>
                    <option value="3">Marzo</option>
                    <option value="4">Abril</option>
                    <option value="5">Mayo</option>
                    <option value="6">Junio</option>
                    <option value="7">Julio</option>
                    <option value="8">Agosto</option>
                    <option value="9">Septiembre</option>
                    <option value="10">Octubre</option>
                    <option value="11">Noviembre</option>
                    <option value="12">Diciembre</option>
                  
              
                </select>
                </div>
                <div className='mx-2'></div>
                <div className='col'>
                <div className='f-16 my-1'>Dinámica:</div>
                <select value={state._activitySelected?.id} onChange={(evt)=>{

                      state._activitySelected = state._activities.find((e)=>e.id === parseInt(evt.currentTarget.value))
                      //  state._activitySelected = evt.currentTarget.value;
                       setState({...state})

                }} className='form-control'>
                    {state._activities.map((activity, i)=>{
                      return(
                        <option key={i} value={activity.id}>{activity.name}</option>
                      )
                    })
                  } 
              
                </select>
                </div>
                <div className='mx-2'></div>

                <div className='col d-flex align-items-end'>
                <div className='f-16 my-1'> &nbsp;</div>

                  <Button className='button--pruple' onClick={()=>{
                    onSearch()
                  }}>
                    Buscar
                  </Button>

                  <Renderif isTrue={state.loading}>
                    <div className="spinner-border text-primary ms-1" role="status"></div>
                  </Renderif>
                  

                  {/* <Button className='button--pruple' onClick={()=>{
                  paintChart(state._chartdays)
                  }}>
                    Pintar
                  </Button> */}

                
            
                </div>


                </div>
                <div className='col'></div>

               

              </div>




              <Line options={options} data={filter()} />;
            </div>

              <div className='card-container mt-3'>

                <div className='text-primary bold f-18 mb-3'>Horas Jugados</div>  

              <div class="chart" id="chart">
                  <div></div>
                  <div class="axis">1</div>
                  <div class="axis">2</div>
                  <div class="axis">3</div>
                  <div class="axis">4</div>
                  <div class="axis">5</div>
                  <div class="axis">6</div>
                  <div class="axis">7</div>
                  <div class="axis">8</div>
                  <div class="axis">9</div>
                  <div class="axis">10</div>
                  <div class="axis">11</div>
                  <div class="axis">12</div>
                  <div class="axis">13</div>
                  <div class="axis">14</div>
                  <div class="axis">15</div>
                  <div class="axis">16</div>
                  <div class="axis">17</div>
                  <div class="axis">18</div>
                  <div class="axis">19</div>
                  <div class="axis">20</div>
                  <div class="axis">21</div>
                  <div class="axis">22</div>
                  <div class="axis">23</div>
                  <div class="axis">24</div>
                  <div class="axis">25</div>
                  <div class="axis">26</div>
                  <div class="axis">27</div>
                  <div class="axis">28</div>
                  <div class="axis">29</div>
                  <div class="axis">30</div>
                  <div class="axis">31</div>

                  {["9:00", "10:00", "11:00", "12:00", "13:00", "14:00", "15:00", "16:00", "17:00", "18:00", "19:00"].map((h,i)=>{
                    return (
                      <>
                        <div class="axis">{h}</div>
                        {
                          [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31].map((d,j)=>{
                  
                            // console.log(state._chartdays.find((e)=>e.day === d)?.hours)
                            let hours = state._chartdays.find((e)=>e.day === d)?.hours
                            let hour = {
                              count:0,
                            };
                            if(hours !== undefined){
                                 hour = hours.find((el)=>el.hour === parseInt(h.split(':')[0]))
                            }
                            console.log(hour)
                            // let hour = hours.find((el)=>el.hour === parseInt(h.split(':')[0]))
                            // console.log(hour)
                           
                            


                            return (
                               <div class="cell" data-day={d} data-hour={h}>{hour?.count !== 0 ? hour?.count : ""}</div>
                            )
                          })
                        }
                      </>
                    )
                  })}



             
                </div>

     

            </div>

            <div className='d-flex flex-wrap mt-2'>

              <div className='col-6  pe-2'>             
                <div className='card-container h-100'>
                  <div className='card-header'>
                    <div className='text-primary bold f-18'>Dinámicas más jugadas</div>      
        
                  </div>
                  <div className='card-body'>


                  <div className='d-flex align-items-center'>
                    <img className='r-5' width={60} src={state.result[0]?.activity?.image}></img>
                      <div className='d-flex flex-column col px-3'>
                        <div className='text-primary bold f-18'>{state.result[0]?.activity?.name}</div>
                        <div className='text-darkblue f-16'> <span className='bold'>{state.result[0]?.count}</span> <span className='text-primary'>Usuarios</span></div>
                      </div>
                      <img className='r-5' width={80} src='./images/Vector_9.png'></img>
                  </div>

                  <div className='d-flex flex-column mt-3'>
                      <div className='d-flex w-100'>
                          <div className='text-primary'>{state.result[1]?.activity?.name}</div>
                          <div className='col'></div>
                          <div className='text-primary'>{state.result[1]?.count} Usuarios</div>
                      </div>
                      <div className='bar'>
                      <div className='bar-active' style={{width: `${state.result[1]?.count * 100 / state.result[0]?.count < 1 ? 1 : state.result[1]?.count * 100 / state.result[0]?.count}%`}}></div>
                      </div>
                  </div>

                        
                  <div className='d-flex flex-column mt-3'>
                    
                      <div className='d-flex w-100 mt-'>
                          <div className='text-primary'>{state.result[2]?.activity?.name}</div>
                          <div className='col'></div>
                          <div className='text-primary'>{state.result[2]?.count} Usuarios</div>
                      </div>

                      <div className='bar'>
                      <div className='bar-active' style={{width: `${state.result[2]?.count * 100 / state.result[0]?.count < 1 ? 1 : state.result[2]?.count * 100 / state.result[0]?.count}%`}}></div>
                      </div>
                  </div>


                  </div>

                  <div className='card-footer'></div>
                </div>
              </div>  

              <div className='col-6 '>
              <div className='card-container h-100'>
                <div className='card-header'>
                  <div className='text-primary bold f-18'>Dinámicas menos jugadas</div>      
       
                </div>
                <div className='card-body'>


                 <div className='d-flex align-items-center'>
                  <img className='r-5' width={60} src={state.result[state.result.length - 1].activity?.image}></img>
                    <div className='d-flex flex-column col px-3'>
                      <div className='text-primary bold f-18'>{state.result[state.result.length - 1].activity?.name}</div>
                      <div className='text-darkblue f-16'> <span className='bold'>{state.result[state.result.length - 1]?.count}</span> <span className='text-primary'>Usuarios</span></div>
                    </div>
                    <img className='r-5' width={80} src='./images/Vector_10.png'></img>
                 </div>

                 <div className='d-flex flex-column mt-3'>
                    <div className='d-flex w-100'>
                        <div className='text-primary'>{state.result[state.result.length - 2].activity?.name}</div>
                        <div className='col'></div>
                        <div className='text-primary'>{state.result[state.result.length - 2]?.count} Usuarios</div>
                    </div>
                    <div className='bar'>


                      <div className='bar-active' style={{width: `${state.result[state.result.length - 2]?.count * 100 / state.result[state.result.length - 3]?.count < 1 ? 1 : state.result[state.result.length - 2]?.count * 100 / state.result[state.result.length - 3]?.count}%`}}></div>
                    </div>
                 </div>


                 <div className='d-flex flex-column mt-3'>
                    <div className='d-flex w-100'>
                    <div className='d-flex w-100'>
                        <div className='text-primary'>{state.result[state.result.length - 3].activity?.name}</div>
                        <div className='col'></div>
                        <div className='text-primary'>{state.result[state.result.length - 3]?.count} Usuarios</div>
                    </div>
                    </div>
                    <div className='bar'>
                      <div className='bar-active' style={{width: `100%`}} ></div>
                    </div>
                 </div>


                </div>

                <div className='card-footer'></div>
              </div>
              </div>

              <div className='col-6 pt-2 pe-2'>
              <div className='card-container h-100'>
                <div className='card-header'>
                  <div className='text-primary bold f-18'>Recompensas Entregadas</div>      
       
                </div>
                <div className='card-body'>


                 <div className='d-flex align-items-center'>
                  <img className='r-5' width={150} src="./images/chart.png"></img>
                  <div className='col ps-3'>
                         
                         <div className='d-flex flex-column'>
                            <div className='d-flex align-items-center'>
                                <div className='dot dot--red me-1'></div>
                                <div className='text-primary'>{state.activities_win[0]?.activity?.name}</div>
                            </div>
                            <div className='d-flex align-items-center'>
                                <div className='dot me-1'></div>
                                <div className=''>{state.activities_win[0]?.count > state.activities_win[0]?.activity?.reward_stock ? state.activities_win[0]?.activity?.reward_stock : state.activities_win[0]?.count } recompensas</div>
                            </div>
                         </div>

                         <div className='d-flex flex-column mt-3'>
                            <div className='d-flex align-items-center'>
                                <div className='dot dot--orange me-1'></div>
                                <div className='text-primary'>{state.activities_win[1]?.activity?.name}</div>
                            </div>
                            <div className='d-flex align-items-center'>
                                <div className='dot me-1'></div>
                             
                                <div className=''>{state.activities_win[1]?.count > state.activities_win[1]?.activity?.reward_stock ? state.activities_win[1]?.activity?.reward_stock : state.activities_win[1]?.count } recompensas</div>
                            </div>
                         </div>

                         <div className='d-flex flex-column mt-3'>
                            <div className='d-flex align-items-center'>
                                <div className='dot dot--blue me-1'></div>
                                <div className='text-primary'>{state.activities_win[2]?.activity?.name}</div>
                            </div>
                            <div className='d-flex align-items-center'>
                                <div className='dot me-1'></div>

                                <div className=''>{state.activities_win[2]?.count > state.activities_win[2]?.activity?.reward_stock ? state.activities_win[2]?.activity?.reward_stock : state.activities_win[2]?.count } recompensas</div>
                            </div>
                         </div>

                     
                  </div>
                   
                  
                 </div>

                 {/* <div className='d-flex flex-column mt-3'>
                    <div className='d-flex w-100'>
                        <div className='text-primary'>{state.activities_stats[1]?.activity?.name}</div>
                        <div className='col'></div>
                        <div className='text-primary'>{state.activities_stats[1]?.count} Usuarios</div>
                    </div>
                    <div className='bar'>
                      <div className='bar-active'></div>
                    </div>
                 </div> */}


                 {/* <div className='d-flex flex-column mt-3'>
                    <div className='d-flex w-100'>
                        <div className='text-primary'>{state.activities_stats[2]?.activity?.name}</div>
                        <div className='col'></div>
                        <div className='text-primary'>{state.activities_stats[2]?.count} Usuarios</div>
                    </div>
                    <div className='bar'>
                      <div className='bar-active'></div>
                    </div>
                 </div> */}


                </div>

                <div className='card-footer'></div>
              </div>
              </div>

              <div className='col-3 pt-2 pe-2'>
              <div className='card-container h-100'>
                <div className='card-header'>
                  <div className='text-primary bold f-18'>Juegos perdidos</div>      
       
                </div>
                <div className='card-body'>


                 <div className='d-flex align-items-center'>
                  <img className='r-5' width={60} src={state.activities_lose[0].activity?.image}></img>
                    <div className='d-flex flex-column col px-3'>
                      <div className='text-primary bold f-18'>{state.activities_lose[0]?.activity?.name}</div>
                      <div className='text-darkblue f-16'> <span className='bold'>{state.activities_lose[0]?.count}</span> <span className='text-primary'>Usuarios</span></div>
                    </div>
                    <img className='r-5' width={80} src='./images/Vector_10.png'></img>
                 </div>

                 <div className='d-flex flex-column mt-3'>
                    <div className='d-flex w-100'>
                        <div className='text-primary'>{state.activities_lose[1]?.activity?.name}</div>
                        <div className='col'></div>
                        <div className='text-primary'>{state.activities_lose[1]?.count} Usuarios</div>
                    </div>
                    <div className='bar'>

                      <div className='bar-active' style={{width: `${state.activities_lose[1]?.count * 100 / state.activities_lose[0]?.count < 1 ? 1 : state.activities_lose[1]?.count * 100 / state.activities_lose[0]?.count}%`}}></div>
                    </div>
                 </div>


                 <div className='d-flex flex-column mt-3'>
                    <div className='d-flex w-100'>
                        <div className='text-primary'>{state.activities_lose[2]?.activity?.name}</div>
                        <div className='col'></div>
                        <div className='text-primary'>{state.activities_lose[2]?.count} Usuarios</div>
                    </div>
                    <div className='bar'>
                      <div className='bar-active' style={{width: `${state.activities_lose[2]?.count * 100 / state.activities_lose[0]?.count < 1 ? 1 : state.activities_lose[2]?.count * 100 / state.activities_lose[0]?.count}%`}}></div>
                    </div>
                 </div>


                </div>

                <div className='card-footer'></div>
              </div>
              </div>

              <div className='col-3 pt-2'>
              <div className='card-container h-100'>
                <div className='card-header'>
                  <div className='text-primary bold f-18'>Juegos ganados</div>      
       
                </div>
                <div className='card-body'>


                 <div className='d-flex align-items-center'>
                  <img className='r-5' width={60} src={state.activities_win[0].activity?.image}></img>
                    <div className='d-flex flex-column col px-3'>
                      <div className='text-primary bold f-18'>{state.activities_win[0]?.activity?.name}</div>
                      <div className='text-darkblue f-16'> <span className='bold'>{state.activities_win[0]?.count}</span> <span className='text-primary'>Usuarios</span></div>
                    </div>
                    <img className='r-5' width={80} src='./images/Vector_9.png'></img>
                 </div>

                 <div className='d-flex flex-column mt-3'>
                    <div className='d-flex w-100'>
                        <div className='text-primary'>{state.activities_win[1]?.activity?.name}</div>
                        <div className='col'></div>
                        <div className='text-primary'>{state.activities_win[1]?.count} Usuarios</div>
                    </div>
                    <div className='bar'>
                  
                    <div className='bar-active' style={{width: `${state.activities_win[1]?.count * 100 / state.activities_win[0]?.count < 1 ? 1 : state.activities_win[1]?.count * 100 / state.activities_win[0]?.count}%`}}></div>
                    </div>
                 </div>


                 <div className='d-flex flex-column mt-3'>
                    <div className='d-flex w-100'>
                        <div className='text-primary'>{state.activities_win[2]?.activity?.name}</div>
                        <div className='col'></div>
                        <div className='text-primary'>{state.activities_win[2]?.count} Usuarios</div>
                    </div>
                    <div className='bar'>
                    <div className='bar-active' style={{width: `${state.activities_win[2]?.count * 100 / state.activities_win[0]?.count < 1 ? 1 : state.activities_win[2]?.count * 100 / state.activities_win[0]?.count}%`}}></div>
                    </div>
                 </div>


                </div>

                <div className='card-footer'></div>
              </div>
              </div>
              


        

            </div>

            <div className='d-flex d-none'>
              <div className='col-6 pt-2 pe-2'>
              <div className='card-container d-flex flex-column'>

                <div className='text-primary bold f-18 mb-3'>Dias Jugados</div>  

                <div className='d-flex'>

              
                 <div className='d-flex flex-column position-relative'>

                  <div className='col d-flex flex-column position-relative' style={{width:30}}>
                      <div className='d-flex flex-column  position-absolute bottom-0 text-center  bold text-gray ' style={{ width:30, height:`${state.max_count * 100 / state.max_count}%`}}>{state.max_count}</div>

                      <div className='d-flex flex-column  position-absolute bottom-0 text-center  bold text-gray' style={{width:30, height:`${(state.max_count * 0.75).toFixed(0) * 100 / state.max_count}%`}}>{(state.max_count * 0.75).toFixed(0)}</div>

                      <div className='d-flex flex-column  position-absolute bottom-0 text-center  bold text-gray' style={{width:30, height:`${((state.max_count * 0.5).toFixed(0)) * 100 / state.max_count}%`}}>{(state.max_count * 0.5).toFixed(0)}</div>

                      <div className='d-flex flex-column  position-absolute bottom-0 text-center  bold text-gray' style={{width:30, height:`${(state.max_count * 0.25).toFixed(0) * 100 / state.max_count}%`}}>{(state.max_count * 0.25).toFixed(0)}</div>
                      {/* <div className='d-flex flex-column  position-absolute bottom-0 text-center  bold text-gray' style={{width:30, height:`${(state.max_count * 0.25).toFixed(0) * 100 / state.max_count}%`}}>{(state.max_count * 0.25).toFixed(0)}</div> */}

                      <div className='d-flex flex-column  position-absolute bottom-0 text-center  bold text-gray' style={{ width:30, height:`0%`}}>1</div>
                  </div>
        
                

                  <div className='text-center'>&nbsp;</div>

                 </div>
               
                
                <div className='col'>

                  <div className='d-flex'>
                  {
                    ['D', 'L', 'M', 'M', 'J', 'V', 'S'].map((day, i)=>{
                
                      let count = state.activities_days.find((x)=>x.day === i)?.count
                      if(count === undefined){
                        count = 0;
                      }
                      let perncentage = count * 100 / state.max_count;
                      return (
                        <div className='col d-flex flex-xl-column justify-content-center align-items-end position-relative' style={{height:300}} key={i}>
                          <div className='col w-100 border-dashed'></div>
                          <div className='col w-100 border-dashed'></div>
                          <div className='col w-100 border-dashed'></div>
                          <div className='col w-100 border-dashed'></div>
                          <div className='col w-100 border-dashed'></div>
                          <div className='col w-100 border-dashed'></div>
                          <div className='col w-100 border-dashed'></div>
                          <div className='col w-100 border-dashed'></div>
                          <div className='col w-100 border-dashed'></div>
                          <div className='col w-100 border-dashed'></div>
                          <div className='col w-100 border-dashed'></div>
                          <div className='col w-100 border-dashed'></div>
                          <div className='col w-100 border-dashed'></div>
                          <div className='col w-100 border-dashed'></div>
                          <div className='col w-100 border-dashed'></div>

                          <div style={{height:`${perncentage}%`, width:'90%', right:'5%'}} className='bar-graph  position-absolute bottom-0'></div>
                          
                          
                          
                          {/* <div className='col'></div>
                          {state.result.map((date, j) => {

                      

                            if(new Date(Date.parse(date.createdAt)).getDay() === i){
                              return (<div className='bg-light mx-4 py-1'></div>)
                            }else{
                              return (<div></div>)
                            }

              
                          })} */}
                        
                        </div>
                      
                      )
                    })
                  }
                  </div>

                  <div className='d-flex'>
                  {
                    ['D', 'L', 'M', 'M', 'J', 'V', 'S'].map((day, i)=>{
                      return (
                        <div className='col d-flex flex-column' key={i}>
                          <div className='text-center mt-2 f-14 bold text-gray '>{day}</div>
                        </div>
                      )
                    })
                  }
                  </div>
             

                </div>

                </div>

              </div>
              </div>

              <div className='col-6 pt-2'>

              <div className='card-container d-flex flex-column'>
              <div className='text-primary bold f-18 mb-3'>Horas Jugadas</div>  

              <div className='d-flex'>
              
                 <div className='d-flex flex-column position-relative ' style={{width:90}}>

                  <div className='col d-flex flex-column  px-1' style={{width:90}}>
                   
                      <div className='col d-flex justify-content-center align-items-center f-14 bold text-gray ' >7pm - 12am</div>
                      <div className='col d-flex justify-content-center align-items-center f-14  bold text-gray' >12pm - 7pm</div>
                      <div className='col d-flex justify-content-center align-items-center f-14  bold text-gray' >7am - 12pm</div>
                      <div className='col d-flex justify-content-center align-items-center f-14  bold text-gray' >12am - 7am</div>

                      {/* <div className='   d-flex flex-column   bottom-0 text-center f-14' style={{width:30, height:`${(state.result.length * 0.75).toFixed(0) * 100 / state.result.length}%`}}>{(state.result.length * 0.75).toFixed(0)}</div>

                      <div className='   d-flex flex-column   bottom-0 text-center f-14' style={{width:30, height:`${((state.result.length * 0.5).toFixed(0)) * 100 / state.result.length}%`}}>{(state.result.length * 0.5).toFixed(0)}</div>

                      <div className='   d-flex flex-column   bottom-0 text-center f-14' style={{width:30, height:`${(state.result.length * 0.25).toFixed(0) * 100 / state.result.length}%`}}>{(state.result.length * 0.25).toFixed(0)}</div>

                      <div className='   d-flex flex-column   bottom-0 text-center f-14' style={{ width:100, height:`${1 * 100 / state.result.length}%`}}>12am - 7am</div> */}
                  </div>
        
                

                  <div className='text-center'>#</div>

                 </div>
               
                
                <div className='col'>

                  <div className='d-flex'>
                  {
                    ['D', 'L', 'M', 'M', 'J', 'V', 'S'].map((day, i)=>{


             

                      let x = state.result.filter((item)=> new Date(Date.parse(item.createdAt)).getDay() === i)
                 
                      let p = []
                      x.map((result, j) => {

                        p.push(parseInt(result.createdAt.split('T')[1].split(':')[0]))

                      })
                     
                      


                      let count = state.activities_days.find((x)=>x.day === i)?.count
                      if(count === undefined){
                        count = 0;
                      }
                      let perncentage = count * 100 / state.result.length;
                      return (
                        <div className='col d-flex flex-column justify-content-center align-items-end' style={{height:300}} key={i}>

                          <div className='col d-flex justify-content-center align-items-center w-100 border-dashed'><Renderif isTrue={
                            p.includes(20) || 
                            p.includes(21) ||
                            p.includes(22) ||
                            p.includes(23)
                            }>
                              <div className='bubble'>
                                {p.filter(x=>x>=20 && x <=23).length}
                              </div>
                            </Renderif></div>

                          <div className='col d-flex justify-content-center align-items-center w-100 border-dashed'><Renderif isTrue={
                            p.includes(12) || 
                            p.includes(13) ||
                            p.includes(14) ||
                            p.includes(15) ||
                            p.includes(16) ||
                            p.includes(17) ||
                            p.includes(18) ||
                            p.includes(19)
                            }>
                            <div className='bubble'>
                            {p.filter(x=>x>=12 && x <=19).length}</div>  
                            </Renderif></div>


              
                        <div className='col d-flex justify-content-center align-items-center w-100 border-dashed'><Renderif isTrue={
                            p.includes(7) || 
                            p.includes(8) ||
                            p.includes(9) ||
                            p.includes(10) ||
                            p.includes(11)
                            }>
                              <div className='bubble'>
                                {p.filter(x=>x>=7 && x <=11).length}
                              </div>
                              </Renderif></div>


                          <div className='col  d-flex justify-content-center align-items-center w-100 border-dashed'><Renderif isTrue={
                            p.includes(0) || 
                            p.includes(1) ||
                            p.includes(2) ||
                            p.includes(3) ||
                            p.includes(4) ||
                            p.includes(5) ||
                            p.includes(6)
                            }>
                              <div className='bubble'>
                              {p.filter(x=>x>=0 && x <=6).length}
                              </div>
                              </Renderif></div>

                          {/* <div style={{height:`${perncentage}%`, width:50}} className='bg-white'></div> */}
                          
                          
                          
                          {/* <div className='col'></div>
                          {state.result.map((date, j) => {

                      

                            if(new Date(Date.parse(date.createdAt)).getDay() === i){
                              return (<div className='bg-light mx-4 py-1'></div>)
                            }else{
                              return (<div></div>)
                            }

              
                          })} */}
                        
                        </div>
                      
                      )
                    })
                  }
                  </div>

                  <div className='d-flex'>
                  {
                    ['D', 'L', 'M', 'M', 'J', 'V', 'S'].map((day, i)=>{
                      return (
                        <div className='col d-flex flex-column' key={i}>
                          <div className='text-center bold text-gray mt-2 f-16'>{day}</div>
                        </div>
                      )
                    })
                  }
                  </div>
             

                </div>

                </div>

              </div>
              </div>

            </div>

          </div>

          <div className='my-5 py-5'></div>
    
       
      </div>
     
    </div>
  )
}

const contentStyle = {
  marginLeft: '15%',
  marginTop: '8vh',
  height: 'calc(100vh - 8vh)',
  background: `linear-gradient(69.94deg, ${Colors.primary} 12.91%, ${Colors.yelmoTurq} 100.4%)`,
  padding: '20px',
  overflowY: 'auto',
}

const contentTitleStyle = {
  color: Colors.white,
  fontSize: '1.5rem',
  marginLeft: '1%',
  marginBlock: '0',
}

export default Home
